import { render, staticRenderFns } from "./transcription.vue?vue&type=template&id=1b6d9692&scoped=true&"
import script from "./transcription.vue?vue&type=script&lang=js&"
export * from "./transcription.vue?vue&type=script&lang=js&"
import style0 from "./transcription.vue?vue&type=style&index=0&id=1b6d9692&prod&lang=scss&scoped=true&"
import style1 from "./transcription.vue?vue&type=style&index=1&id=1b6d9692&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d9692",
  null
  
)

export default component.exports